import { Link } from "react-router-dom";
import { TrendUp } from "@phosphor-icons/react";

export default function AIToolCard({ tool }) {
  const { slug, emoji, name, category, description, score, isNew, is_sponsored } = tool;
  const id = slug ?? tool.id;

  return (
    <Link
      to={`/ai-tools/${id}`}
      className="group block bg-white border border-slate-200 rounded-xl p-5 hover:border-green-300 hover:shadow-md transition-all"
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-3">
          <span className="text-2xl leading-none">{emoji}</span>
          <div>
            <h3 className="font-semibold text-sm text-slate-900 group-hover:text-green-700 transition-colors">
              {name}
            </h3>
            <span className="text-[10px] font-medium uppercase tracking-wider text-slate-400">
              {category}
            </span>
          </div>
        </div>
        <div className="flex flex-col items-end gap-1 shrink-0">
          {is_sponsored && (
            <span className="text-[10px] font-bold uppercase tracking-wider text-amber-700 bg-amber-50 border border-amber-200 px-1.5 py-0.5 rounded-full">
              Sponsored
            </span>
          )}
          {isNew && !is_sponsored && (
            <span className="text-[11px] font-bold uppercase tracking-wider text-green-700 bg-green-50 border border-green-200 px-1.5 py-0.5 rounded-full">
              New
            </span>
          )}
        </div>
      </div>
      <p className="text-xs text-slate-500 leading-relaxed mb-4">{description}</p>
      <div className="flex items-center gap-1">
        <TrendUp size={12} className="text-green-500" />
        <span className="text-xs font-semibold text-slate-700">
          {score}
          <span className="font-normal text-slate-400"> score</span>
        </span>
      </div>
    </Link>
  );
}
